export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/environments/environment.ts